export const queryKeys = {
  directScheduleAdjustment: 'directScheduleAdjustment',
  directScheduleAdjustmentCalendar: 'directScheduleAdjustmentCalendar',
  directScheduleAdjustmentTimeframe: 'directScheduleAdjustmentTimeframe'
};
